import { shortenUrl } from '@/services/shortenUrl';
import { ShortenUrlInput, ShortenUrlRes } from '@/types/disclaimer';
import { createMutation } from 'react-query-kit';

export const useShortenUrlMutation = createMutation<
  ShortenUrlRes,
  ShortenUrlInput,
  Error
>({
  mutationFn: ({ long_url }) => shortenUrl(long_url),
});
